
import * as t from "io-ts";
import fetchApi from "../fetch-api";

const FilterCodec = t.type({
  name: t.string,
  userID: t.string,
  userName: t.string,
  metadata: t.unknown,
  addedOn: t.number,
  modifiedOn: t.number,
  isDeleted: t.boolean,
  isInActive: t.boolean,
  filterID: t.string,
});

export const getSearchFiltersByUser= ({userID}: {userID: string}) => {
  return {
    queryKey: ["GET_SEARCH_FILTERS", userID],
    queryFn: () =>
      fetchApi({
        service:"core-service",
        method: 'GET',
        pathname: `/get-search-filters/${userID}`,
        codec: t.array(FilterCodec),
      }),
  };
};
